
// Add a type declaration for the confetti function
declare global {
  interface Window {
    confetti?: (options?: {
      particleCount?: number;
      spread?: number;
      origin?: { y: number };
      colors?: string[];
    }) => void;
  }
}

export const MEASUREMENT_UNITS = [
  "pages", "kilometers", "meters", "steps", "hours", "minutes", "liters", "milliliters"
];

export const formatUnit = (unit: string): string => {
  return unit.toLowerCase()
    .replace(/^pages?$/, 'pages')
    .replace(/^kilometers?$/, 'kilometers')
    .replace(/^meters?$/, 'meters')
    .replace(/^steps?$/, 'steps')
    .replace(/^hours?$/, 'hours')
    .replace(/^minutes?$/, 'minutes')
    .replace(/^liters?$/, 'liters')
    .replace(/^milliliters?$/, 'milliliters');
};

export const formatValue = (value: number, unit: string): string => {
  if (unit.toLowerCase().includes('page')) {
    return Math.round(value).toString();
  }
  return value.toFixed(0);
};

export const triggerConfetti = () => {
  const confetti = window.confetti;
  if (confetti) {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ["#FFD700", "#FFA500", "#FFB6C1"],
    });
  }
};
